import { useColorModeValue } from "@/components/ui/color-mode"

/**
 * Centralized semantic color system for dark/light mode.
 * Use these instead of hardcoded color="white", color="gray.400", etc.
 */
export function useSemanticColors() {
  return {
    // Text hierarchy
    heading: useColorModeValue("#1a202c", "#edf3ff"),
    text: useColorModeValue("#2D3748", "#d8e0f4"),
    textMuted: useColorModeValue("#718096", "#A0AEC0"),
    textSubtle: useColorModeValue("#A0AEC0", "#718096"),
    textSecondary: useColorModeValue("#4A5568", "#CBD5E0"),

    // Backgrounds
    pageBg: useColorModeValue("#f7f8fc", "#0e1228"),
    cardBg: useColorModeValue("white", "transparent"),
    hoverBg: useColorModeValue("rgba(0,0,0,0.04)", "rgba(255,255,255,0.04)"),
    activeBg: useColorModeValue("rgba(0,0,0,0.06)", "rgba(255,255,255,0.06)"),
    eventBg: useColorModeValue("rgba(0,0,0,0.02)", "rgba(0,0,0,0.2)"),

    // Borders
    border: useColorModeValue("#E2E8F0", "rgba(255,255,255,0.1)"),
    borderMuted: useColorModeValue("#EDF2F7", "rgba(255,255,255,0.06)"),

    // Toggle / pill backgrounds
    toggleBg: useColorModeValue("rgba(0,0,0,0.06)", "rgba(255,255,255,0.06)"),
    toggleActiveBg: useColorModeValue(
      "rgba(0,0,0,0.12)",
      "rgba(255,255,255,0.12)",
    ),

    // Table-specific
    tableHeaderColor: useColorModeValue("#4A5568", "#A0AEC0"),
    tableCellColor: useColorModeValue("#2D3748", "#d8e0f4"),
    tableCellMuted: useColorModeValue("#4A5568", "#CBD5E0"),
    tableBorderColor: useColorModeValue("#EDF2F7", "rgba(255,255,255,0.06)"),

    // Spinner / icons
    spinnerColor: useColorModeValue("#4A5568", "white"),
    iconColor: useColorModeValue("#4A5568", "white"),
    iconMuted: useColorModeValue("#718096", "#A0AEC0"),

    // Accent colors
    accentText: useColorModeValue("#3182CE", "#63B3ED"),
    indicatorBg: useColorModeValue("#4299E1", "#63B3ED"),
  }
}
